var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email"},[_c('a',{staticClass:"contact-link u-email",attrs:{"href":`mailto:${_vm.address}`}},[_c('Sprite',{staticClass:"email-icon",attrs:{"name":"email"}}),_c('div',{staticClass:"address value"},[_vm._v("\n        "+_vm._s(_vm.address)+"\n      ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }